import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParsePostNr } from '../Parsers/TEDParsePostNr';
import { TEDDisplayPostNr } from '../Displayers/TEDDisplayPostNr';

class TEDFormatPostNr implements IFormatter {
  displayer = TEDDisplayPostNr.getInstance();
  parser = TEDParsePostNr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatPostNr };
